/**
 * Single source of truth for the public site's horizontal content bounds.
 * Mirrors the public header container EXACTLY so every public page shell and
 * major public section aligns its left/right edges with the header.
 *
 * Do NOT reintroduce narrower outer wrappers (max-w-2xl/3xl/4xl/5xl) at the
 * page/section level. Readable inner text blocks are allowed only INSIDE this.
 */
export const PUBLIC_CONTAINER = 'max-w-6xl mx-auto px-4 sm:px-6 lg:px-8';

export const PublicContainer = ({ as: Tag = 'div', className = '', children, ...rest }) => (
  <Tag className={`${PUBLIC_CONTAINER}${className ? ` ${className}` : ''}`} {...rest}>
    {children}
  </Tag>
);

export default PublicContainer;
